import React, {useEffect, useState} from 'react';
import Aux from '../../hoc/Aux/Aux';
import ProjectListItemPlaceholder
    from '../../components/UI/Placeholder/ProjectListItemPlaceholder/ProjectListItemPlacholder';
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";
import ProjectListItem from './ProjectListItem/ProjectListItem';
import CallToAction from '../../components/CallToAction/CallToAction';
import styles from './ProjectList.module.scss';
import axios from '../../axios-base';
import ECB from '../../components/ECB/ECB';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import {Col, Row} from 'reactstrap';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import thumbnailPlaceholder from '../../assets/images/project-thumbnail-placeholder.webp';
import FormInput from '../../components/UI/Input/FormInput';
import {sendVirtualPageView} from '../../shared/utility';
import qs from 'qs';
import {Helmet} from "react-helmet";
import NumbersAndBrand from "./NumbersAndBrand/NumbersAndBrand";
import Cookies from "js-cookie";
import {CssMasonry} from "../../components/Masonry/CssMasonry";

const {determineVotes} = require('../../shared/VoteEvaluatorFunctions');

function ProjectListHook(props) {
    const cookieName = "bigfoot_numbers-and-brand";
    const [projects, setProjects] = useState(null);
    const [phrase, setPhrase] = useState('');
    const [categoryOptions, setCategoryOptions] = useState(null);
    const [categorySelected, setCategorySelected] = useState('');
    const [cta, setCta] = useState(null);
    const [ecb, setEcb] = useState([]);
    const [inputSelection, setInputSelection] = useState(true);
    const [isNumbersAndBrandVisible, setIsNumbersAndBrandVisible] = useState(!Cookies.get(cookieName) && process.env.REACT_APP_NUMBERS_AND_BRAND_COMPONENT === 'true');

    const location = useLocation();
    let history = useHistory();

    useEffect(() => {
        const cta = axios.get('/cta/', {params: {page: 'projekte'}})
        const options = axios.get('/options/')
        const ecbRequest = axios.get('/ecb/');

        Promise.all([cta, options, ecbRequest]).then(([resCta, resOptions, resEcb]) => {
            setCta(resCta.data[0]);
            setEcb(resEcb.data);

            let availableCategories = resOptions.data[0].projectForm.projectCategory;
            if (availableCategories && availableCategories.elementConfig.options.length > 1) {
                let firstOption = () => {
                    if (availableCategories.dependent) {
                        return {value: "", displayValue: "Alle"}
                    } else {
                        return {
                            value: "",
                            displayValue: "Eine " + availableCategories.elementConfig.label + " wählen",
                            disabled: true
                        }
                    }
                }

                availableCategories.elementConfig.options.unshift(firstOption());
                availableCategories.elementConfig.label = "Teilnehmende nach " + availableCategories.elementConfig.label + " filtern";
                setCategoryOptions(availableCategories);
            }
        }).catch((error) => {
            console.log(error);
        });
        sendVirtualPageView("Teilnehmer");
    }, []);

    useEffect(() => {
        const query = qs.parse(location.search.slice(1)).category;
        setProjects(null);
        axios.get(`/projects/?category=${query}`)
            .then(response => {
                setProjects(response.data);
                setCategorySelected(query !== undefined ? query : "");
                setInputSelection(true);
                setCategorySelected(query !== undefined ? query : "");
                setInputSelection(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, [location])

    const categoryHandler = (e) => {
        const selectedCategory = e.target.value;
        setPhrase('');
        setInputSelection(false);
        if (selectedCategory !== categorySelected) {
            setCategorySelected(selectedCategory);
            history.push({
                search: `?category=${selectedCategory}`
            });
        }
    };

    const onChangeHandler = (e) => {
        setPhrase(e.target.value);
        if (categorySelected !== '' && categoryOptions.dependent) {
            setCategorySelected('');
            history.push({
                search: `?category=`
            });
        }
    };

    let categoryForm;
    if (categoryOptions) {
        categoryForm = (<FormInput
            wrapperCSSClass='category-select mb-3'
            elementType={categoryOptions.elementType}
            elementConfig={categoryOptions.elementConfig}
            value={categorySelected}
            changed={(e) => categoryHandler(e)}
            disabled={!inputSelection}
            shouldValidate={categoryOptions.valid}
            helperText={`${categoryOptions.elementConfig.label}. Wie z.B. ${categoryOptions.elementConfig.options[1].displayValue} oder ${categoryOptions.elementConfig.options[2].displayValue}`}/>);
    }

    // Combine and sort projects and ECB data
    const combinedItems = [
        ...ecb.map(item => ({
            ...item,
            type: 'ecb'
        })),
        ...(projects && props.votingPhases) ? projects.map((project, index) => ({
            ...project,
            type: 'project',
            order: index
        })) : []];

    combinedItems.sort((a, b) => a.order - b.order);

    const filteredItems = combinedItems.filter(item => item.type === 'project' ? (item.contestantName.toLowerCase() + " " + item.projectTitle.toLowerCase()).includes(phrase.toLowerCase()) : true);


    let projectsRender = (<Aux>
        <ProjectListItemPlaceholder/>
        <ProjectListItemPlaceholder/>
        <ProjectListItemPlaceholder/>
    </Aux>);

    if (projects && props.votingPhases) {
        projectsRender = filteredItems.map(item => {
            if (item.type === 'ecb') {
                return (
                    <Col key={item._id}>
                        <ECB assetUrl={item.assetUrl} altText={item.altText} link={item.link}/>
                    </Col>
                );
            } else {
                let projectVoteCount = 0;
                let projectRank = '-';
                if (item) {
                    projectRank = item.rank;
                    projectVoteCount = determineVotes(item.voteCount, props.votingPhases);
                }
                return (
                    <Col className="d-flex" key={item._id}>
                        <NavLink className={`h-100 ${styles.ProjectListLink} flex-grow-1`} to={'./' + item._id}>
                            <ProjectListItem
                                key={item._id}
                                achievements={item.achievements}
                                image={item.projectGallery.length ? item.projectGallery[0].url : thumbnailPlaceholder}
                                rank={projectRank}
                                name={item.contestantName}
                                title={item.projectTitle}
                                shortDescription={item.projectShortDescription}
                                voteCount={projectVoteCount}
                                imageSrc={item.projectGallery[0] && item.projectGallery[0].url}
                                projectBalance={item.fundingAccount.balance}
                                phases={props.votingPhases}
                                fundingStages={props.fundingStages}
                                aria-hidden={true}
                            >
                                {/* @Todo: Deep-Link zur Ressource definieren und Pretty-Link erstellen */}
                            </ProjectListItem>
                            <p className="visually-hidden">
                                {`${item.contestantName}${item.projectTitle ? " (" + item.projectTitle + ")" : ""} mit ${projectVoteCount} Stimmen: ${item.projectShortDescription}`}
                            </p>
                        </NavLink>
                    </Col>
                );
            }
        });
    }

    let ctaRender = <CallToActionPlaceholder/>;

    if (cta) {
        ctaRender = <CallToAction
            headline={cta.headline}
            copy={cta.copy}
            buttonText={cta.buttonText}
            buttonColor={cta.buttonColor}
            linkUrl={cta.linkUrl}
            outline={cta.outline}
            buttonVisibility={cta.buttonVisibility}
        />
    }

    // dismissNumbersAndBrand is passed as a prop to NumbersAndBrand
    const dismissNumbersAndBrand = () => {
        Cookies.set(cookieName, true, 180);
        setIsNumbersAndBrandVisible(false);
    };
    const searchColClass = isNumbersAndBrandVisible ? "col-sm-12 col-lg-8" : "col-12";

    return (<Aux>
        <Helmet>
            <title>{`Teilnehmende | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
        </Helmet>
        {/* CallToAction */}
        <Row className="row row-cols-1 ">
            {isNumbersAndBrandVisible && (<NumbersAndBrand dismissNumbersAndBrand={dismissNumbersAndBrand}/>)}
            <Col className="my-3 order-lg-1">
                {ctaRender}
            </Col>
            <Col className={searchColClass + " order-lg-2"}>
                <div className={styles.ProjectListCounterContainer + " bg-light pt-3 p-3 m-0 mb-3 border"}>
                    {categoryForm}
                    <div className="mb-3 project-search">
                        <FormInput disabled={!inputSelection}
                                   changed={onChangeHandler}
                                   inlineIcon={faSearch}
                                   label="Teilnehmende suchen"
                                   elementConfig={{
                                       label: "Teilnehmende suchen", placeholder: "Musterverein e.V.", type: "search"
                                   }}
                                   elementType="search"
                                   helperText="Freitextsuche nach einem Teilnehmenden"
                                   value={phrase}/>
                    </div>
                </div>
            </Col>
        </Row>
        <CssMasonry>
            {projectsRender}
        </CssMasonry>
    </Aux>);
}

export default ProjectListHook;
